export default __webpack_public_path__ + "static/bg_image_blue@2x-b0d3caf6fd8e0bdb9d98479f213b2f3d.webp";